import React from 'react';
import { isVatActive } from '../../../utils/ecommerce/vat.js';
import { VAT_BUSS_PRICE, VAT_CONS_PRICE, VAT_SHOWING, VAT_VIEW } from '../data/Localization';

const VatSwitcher = () => {
	const capitalizeFirstWord = (str) => {
		if (!str || typeof str !== 'string') {
			return str;
		}

		return str.charAt(0).toUpperCase() + str.slice(1);
	};

	let isVatActiveVal = isVatActive();
	let priceSelectionText = isVatActiveVal ? VAT_CONS_PRICE : VAT_BUSS_PRICE;
	let currPriceSelection = capitalizeFirstWord(priceSelectionText);

	let currURL = window.location.href;
	let oppositeParamPrice = isVatActiveVal ? 'business' : 'consumer'; // this strings are not public are for internal logic.
	let oppositeVatPrice = isVatActiveVal ? VAT_BUSS_PRICE : VAT_CONS_PRICE;
	currURL = currURL.includes('?') ? `${currURL}&changePriceVatTo=${oppositeParamPrice}` : `${currURL}?changePriceVatTo=${oppositeParamPrice}`;

	return (
		<p style={{ 'textAlign': 'center' }}>
			{currPriceSelection} {VAT_SHOWING}. {VAT_VIEW}{' '}
			<a className="calcite-link" href={currURL}>
				{oppositeVatPrice}
			</a>
		</p>
	);
};

export default VatSwitcher;
